import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import funcionCambioURL from '../../../../funciones/gestionURL';
import { useNavigate , useLocation} from 'react-router-dom';

export default function SelectSubcategoria({ subcategorias }) {
    const navigate = useNavigate();
    const location = useLocation();

    const conseguirSubcategoriaURL = () => {
        const params = new URLSearchParams(location.search);
        return (params.get('subcategoria')) || '';
    };
    const [subcategoria, setSubcategoria] = useState(conseguirSubcategoriaURL);
    const cambioURL = funcionCambioURL('subcategoria');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const valorActualURL = params.get('subcategoria') || '';
        setSubcategoria(valorActualURL);
    }, [location.search]);

    const handleChange = (event) => {
        const subcategoriaSeleccionada = event.target.value;
        setSubcategoria(subcategoriaSeleccionada);
        const nuevaURL =cambioURL(subcategoriaSeleccionada);
        navigate(nuevaURL); 
    };

    return (
        <div>
            <FormControl sx={{ ml: 1, width: 150 }}>
                <InputLabel id="demo-simple-select-label">Subcategoria</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={subcategoria}
                    label="Subcategoria"
                    onChange={handleChange}
                >
                    <MenuItem value="">
                        {subcategorias.length === 0 ? "No hay subcategorias disponibles" : "Todos"}
                    </MenuItem>

                    {subcategorias.map((subcat) => (
                        <MenuItem key={subcat.Id} value={subcat.url}>
                            {subcat.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
